import { FileStatus } from '@/lib/types';
import useCardThumbnailFileStatusRefreshing from './useCardThumbnailFileStatusRefreshing';
import ThumbnailLoadingPlaceholder from './ThumbnailLoadingPlaceholder';
import ThumbnailImage from './ThumbnailImage';
import { useContext } from 'react';
import PortfolioItemCardThumbnailContext from './PortfolioItemCardThumbnailContext';

const PortfolioItemCardThumbnail = () => {
  useCardThumbnailFileStatusRefreshing();

  const { portfolioItemSummary } = useContext(
    PortfolioItemCardThumbnailContext,
  );

  if (
    [
      FileStatus.ANTIVIRUS_QUARANTINED,
      FileStatus.INAPPROPRIATE_CONTENT_DETECTED,
    ].includes(portfolioItemSummary.thumbnail.file.status) ||
    (portfolioItemSummary.thumbnail.file.status === FileStatus.READY &&
      portfolioItemSummary.thumbnail.file.thumbnailStorageFilename === null)
  ) {
    return null;
  }

  if (portfolioItemSummary.thumbnail.file.status !== FileStatus.READY) {
    return <ThumbnailLoadingPlaceholder />;
  }

  return <ThumbnailImage />;
};

export default PortfolioItemCardThumbnail;
